import type { DocumentFillerRun, DocumentFillPreview, DocumentFillTemplate } from "@/schema"

import { ApiContext, apiContextFetch } from "@/hooks/api/base"

export interface DocumentFillTemplatesResponse {
  document_templates: DocumentFillTemplate[]
}

export interface PreviewDocumentFillParams {
  template_id: string
  person_id?: string
  advisor_id?: string
  head_of_household_person_id?: string
  spouse_or_partner_person_id?: string
}

export interface CreateDocumentFillParams {
  template_id: string
  person_id?: string
  advisor_id?: string
  head_of_household_person_id?: string
  spouse_or_partner_person_id?: string
  editable_after_fill?: boolean
  allow_empty_required_fields?: boolean
  field_values: Record<string, string | boolean>
}

export async function fetchDocumentFillTemplates(
  context: ApiContext,
  householdId: string
): Promise<DocumentFillTemplatesResponse> {
  return apiContextFetch<DocumentFillTemplatesResponse>(context, `households/${householdId}/document_fills`)
}

export async function previewDocumentFill(
  context: ApiContext,
  householdId: string,
  params: PreviewDocumentFillParams
): Promise<DocumentFillPreview> {
  return apiContextFetch<DocumentFillPreview>(context, `households/${householdId}/document_fills/preview`, {
    method: "POST",
    body: JSON.stringify(params),
  })
}

export async function createDocumentFill(
  context: ApiContext,
  householdId: string,
  params: CreateDocumentFillParams
): Promise<DocumentFillerRun> {
  return apiContextFetch<DocumentFillerRun>(context, `households/${householdId}/document_fills`, {
    method: "POST",
    body: JSON.stringify(params),
  })
}

export async function fetchDocumentFillerRun(context: ApiContext, id: string): Promise<DocumentFillerRun> {
  return apiContextFetch<DocumentFillerRun>(context, `document_filler_runs/${id}`)
}
